import { Amplify } from 'aws-amplify';
import {
  signIn,
  signOut,
  confirmSignIn,
  fetchAuthSession,
  fetchUserAttributes,
} from 'aws-amplify/auth';

import { notification } from 'antd';
import { setToken } from './authentication';
import { awsConfig } from './aws-exports';

const environment = env || 'LOCAL';
Amplify.configure(awsConfig[environment]);

// Return true to navigate to dashboard
export async function login(email: string, password: string) {
  let returnValue = '';

  try {
    const { nextStep } = await signIn({ username: email, password });
    if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      returnValue = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';
    }
    returnValue = 'SUCCESS';
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in to Wahed Invest Dashboard!',
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: 'Login Failed',
      description: 'Please enter the correct credentials to continue.',
      duration: 3,
    });
  }
  return returnValue;
}

export const fetchCurrentAccount = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    const userAttributes = await fetchUserAttributes();

    const {
      tokens: {
        idToken,
        idToken: {
          payload: { exp },
        },
      },
    } = session;

    setToken(idToken?.toString() ?? '', exp);

    return { success: true, response: { session, userAttributes } };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
// Return true to logout of dashboard
export const logout = async () => {
  try {
    await signOut();
    return true;
  } catch (error) {
    console.error('error => ', error);
    return false;
  }
};

export const newPasswordChallenge = async (newPassword: string) => {
  let hasPasswordChanged = false;
  try {
    const { isSignedIn } = await confirmSignIn({ challengeResponse: newPassword });
    if (isSignedIn) {
      notification.success({
        message: 'Logged In',
        description: 'You have successfully logged in to Wahed Invest Dashboard!',
        duration: 3,
      });
    }
    hasPasswordChanged = isSignedIn;
  } catch (error) {
    notification.error({
      message: 'Login Failed',
      description: 'Please enter the correct credentials to continue.',
      duration: 3,
    });
  }
  return hasPasswordChanged;
};
